<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="14" viewBox="0 0 40 14" fill="none">
    <path d="M15.0024 12.002L0 0H40L24.9976 12.002C22.0758 14.3394 17.9242 14.3393 15.0024 12.002Z" class="white-fill" />
  </svg>
</template>

<style lang="scss" scoped>
.white-fill {
  fill: #0f0f0f;
}
.dark {
  .white-fill {
    fill: #f5f5f5;
  }
}
</style>
